<template>
        <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title label-black">Actualización de Estatus a Incidencia Folio: {{this.Folio}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-12" >
                            <label class="label-black">Tipo de Incidencia</label>
                            <input type="text" class="form-control" v-model="incidencia.TipoIncidencia.Nombre"/>
                        </div>
                    </div>
                    <div class="row" v-if="incidencia.TipoSubIncidencia!=null">
                        <div class="form-group col-12" >
                            <label class="label-black">Categoria</label>
                            <input type="text" class="form-control" v-model="incidencia.TipoSubIncidencia.Nombre" />
                        </div>
                    </div>

                    <TipoEstatus
                    v-on:valorParaElPadre="cambioDeIncidencia" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="'catalogoEstatusIncidencias'" 
                    :parametros="parametros_Incidencia" 
                    :valorDefinido="parametros_Incidencia.tipoEstatusIncidenciaId"
                    :key="parametros_Incidencia.tipoEstatusIncidenciaId"
                    ></TipoEstatus>
                    <div class="row" v-if="parametros_Incidencia.tipoEstatusIncidenciaId==4">
                        <div class="form-group col-12" >
                            <label class="label-black">Motivo de Cancelación</label>
                            <textarea type="text" class="form-control" v-model="Motivo" />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
                    <button type="button" class="btn btn-custom" id="botonAceptar" >Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'

export default {
    props:{
        incidencia: Object,
        nomina: {
            type: Number,
            default: 0
        }
    },
    components: {
        TipoEstatus: catalogos.SIAP.C032TipoEstatusIncidencias
    },
    data(){
        return{
            enumeraciones,
            parametros_Incidencia: {
                tipoEstatusIncidenciaId: -1
            },
            Motivo:"",
            Folio:""
        }
    },
    methods: {
        Mostrar: function () {
        $('#modalEnvio').modal('show');
        $('#botonCancelar').unbind('click').click(this.Cancelar);
        $('#closeModal').unbind('click').click(this.CerrarModal);
        $('#botonAceptar').unbind('click').click(this.CambiarIncidencia);
        },
        ModalClose: function(b1, b2, nom){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {'Cerrar':b1, 'Actualizar':b2, 'Nomina':nom});
        },
        Cancelar(){
            this.ModalClose(false,false, this.nomina)
        },
        CambiarIncidencia(){
            if(this.validaCampos()==true)
            {
                    var peticion = {
                    "Incidencia": {
                        "IncidenciaId": this.incidencia.IncidenciaId,
                        "PersonaIncidencia": this.incidencia.PersonaIncidencia,
                        "Detalles": this.incidencia.Detalles,
                        "EstatusIncidencia": { "TipoEstatusIncidenciaId": this.parametros_Incidencia.tipoEstatusIncidenciaId},
                        "MotivoCancelacion": this.Motivo
                        }
                    };
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.SIAP.funcion.CambiaEstatusIncidencia, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then(respuesta => {
                        if (respuesta.data.SiHayError){
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }
                        else
                        {
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                            comun.SeEstaCargandoInformacion(false);
                            this.ModalClose(false, true, this.nomina);
                        }
                        comun.SeEstaCargandoInformacion(false);
                        
                    })
                    .catch(e=> {
                        console.log("No Hay Respuesta del Servidor", e);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                    });
            }
        },
        cambioDeIncidencia(datos){
            this.parametros_Incidencia.tipoEstatusIncidenciaId = parseInt(datos.target.value);
        },
        validaCampos(){
            if(this.parametros_Incidencia.tipoEstatusIncidenciaId== -1)
            {
                comun.mensajeDeAlerta("Seleccione un Estatus valido", null, null);
                return false;
            };
            if(this.parametros_Incidencia.tipoEstatusIncidenciaId==this.incidencia.EstatusIncidencia.TipoEstatusIncidenciaId)
            {
                comun.mensajeDeAlerta("Seleccione un Estatus diferente al actual", null, null);
                return false;
            };
            if(this.parametros_Incidencia.tipoEstatusIncidenciaId==4)//Cancelacion
            {
                if(this.Motivo=="" || this.Motivo==null || this.Motivo == undefined)
                {
                    comun.mensajeDeAlerta("Describa Motivo de Cancelación", null, null);
                    return false;
                }
            };
            return true;
        }
    },
    mounted(){
        this.parametros_Incidencia.tipoEstatusIncidenciaId = this.incidencia.EstatusIncidencia.TipoEstatusIncidenciaId;
        this.Folio = this.incidencia.IncidenciaId;
        this.Mostrar()
    }
}
</script>

<style scoped>
    input[type="text"]:read-only {
        background: #f3f3f3;
    }
    textarea[type="text"]:read-only {
        background: #f3f3f3;
    }
    .modal {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        display: none;
        overflow: hidden;
        outline: 0;
    }
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .modal-content {
        background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/SIAP/Incidencias/ModalEstatus.vue